import React from 'react';
import classnames from 'classnames';
import { CheckCircleFilled, CloseCircleFilled, ClockCircleOutlined } from '@ant-design/icons';

import { TagType } from '~constants/tagType';

const ACCEPT = 'accept';

const Tag = ({ t, tagType, descType, showTagDesc }) => {
  const isCounterOffer = tagType === TagType.counterOffer;
  const isAccept = descType === ACCEPT;
  return (
    <div className="tag-wrapper">
      <div className={classnames('tag', `tag__${tagType}`)}>
        <If condition={isCounterOffer}>
          <span className="tag-icon">
            <ClockCircleOutlined />
          </span>
        </If>
        <span>{t(`landlord.booking.counter_offer.detail.${tagType}`)}</span>
      </div>
      <If condition={showTagDesc && descType}>
        <div className="tag-desc">
          <span
            className={classnames(
              'tag-desc__icon',
              isAccept && !isCounterOffer && 'tag-desc__icon-counter_offer',
            )}
          >
            {isAccept && !isCounterOffer ? <CheckCircleFilled /> : <CloseCircleFilled />}
          </span>
          <span className="tag-desc__content">
            {isAccept && !isCounterOffer
              ? t('landlord.booking.counter_offer.detail.tag_desc.accept')
              : t('landlord.booking.counter_offer.detail.tag_desc.reject')}
          </span>
        </div>
      </If>
    </div>
  );
};

export default Tag;
